// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LOX0a0O7 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  z-index: 2000;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  padding: 1rem;
}
@media (max-width: 767px) {
  .LOX0a0O7 {
    padding: 1rem;
  }
}
.gQJkD7ql {
  position: relative;
  background: #ffffff;
  border-radius: 0.75rem;
  max-width: 25rem;
  width: 100%;
  padding: 1.5rem 1.5rem 2rem;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  -webkit-animation: mcKbNPz4 0.3s ease;
          animation: mcKbNPz4 0.3s ease;
}
@media (max-width: 767px) {
  .gQJkD7ql {
    max-width: 90%;
    padding: 1rem 1.5rem;
  }
}
@-webkit-keyframes mcKbNPz4 {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
@keyframes mcKbNPz4 {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
.WApmN42S {
  font-size: 1.5rem;
  font-weight: bold;
  color: #000;
  text-align: center;
  margin: 0 0 1rem 0;
  line-height: 1.4;
}
@media (max-width: 767px) {
  .WApmN42S {
    font-size: 1.5rem;
  }
}
.SHk21N_n {
  font-size: 1rem;
  color: #585858;
  text-align: center;
  margin: 0 0 0.5rem 0;
  line-height: 1.6;
  font-weight: bold;
}
@media (max-width: 767px) {
  .SHk21N_n {
    font-size: 1rem;
  }
}
.FZw_1agI {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  margin: 1.5rem 0 2rem 0;
}
@media (max-width: 767px) {
  .FZw_1agI {
    margin: 1rem 0 1rem 0;
  }
}
.T12XyjTO {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.nyWdBqGD {
  width: 1rem;
  height: 1rem;
  cursor: pointer;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 1px solid #d0d0d0;
  border-radius: 50%;
  background: #ffffff;
  position: relative;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  box-shadow: 0 0 2px rgba(208, 208, 208, 0.3);
}
.nyWdBqGD:checked {
  border-color: #d0d0d0;
  background: #ffffff;
}
.nyWdBqGD:checked::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  background: #5B5B5B;
}
.nyWdBqGD:hover {
  border-color: #b0b0b0;
  box-shadow: 0 0 3px rgba(208, 208, 208, 0.5);
}
.yqATvQDr {
  font-size: 0.875rem;
  color: #666666;
  font-weight: bolder;
}
@media (max-width: 767px) {
  .yqATvQDr {
    font-size: 0.75rem;
  }
}
.RWMceyS6 {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  gap: 1rem;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
          justify-content: space-between;
}
@media (max-width: 767px) {
  .RWMceyS6 {
    gap: 1.5rem;
    width: 100%;
    margin: 0 auto;
  }
}
.GdIqccVx {
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  aspect-ratio: 72 / 25;
  min-height: 1.5625rem;
  background: #626CDA;
  border: none;
  border-radius: 999px;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  min-height: 2.75rem;
  min-width: 2.75rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
}
.GdIqccVx:hover {
  background: #3945d0;
}
.GdIqccVx:active {
  -webkit-transform: scale(0.98);
          transform: scale(0.98);
}
@media (max-width: 767px) {
  .GdIqccVx {
    font-size: 0.875rem;
  }
}
.JeyKI33F {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  aspect-ratio: 72 / 25;
  min-height: 1.5625rem;
  background: #ffffff;
  border: 1px solid #d0d0d0;
  border-radius: 999px;
  color: #666666;
  font-size: 1rem;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  min-height: 2.75rem;
  min-width: 2.75rem;
  font-weight: normal;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
}
.JeyKI33F:hover {
  background: #f5f5f5;
}
.JeyKI33F:active {
  -webkit-transform: scale(0.98);
          transform: scale(0.98);
}
@media (max-width: 767px) {
  .JeyKI33F {
    font-size: 0.875rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LogoutModal/LogoutModal.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,kCAAA;UAAA,0BAAA;EACA,aAAA;ECkBA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EDlBA,aAAA;AAAF;ACTE;EAAA;IDYE,aAAA;EACF;AACF;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,2BAAA;EACA,yCAAA;EACA,qCAAA;UAAA,6BAAA;AAAF;ACxBE;EAAA;ID2BE,cAAA;IACA,oBAAA;EACF;AACF;AAEA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EAAF;EAEA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EAAF;AACF;AARA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EAAF;EAEA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EAAF;AACF;AAGA;EACE,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AADF;AChDE;EAAA;IDoDE,iBAAA;EAAF;AACF;AAGA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;AADF;AC7DE;EAAA;IDiEE,eAAA;EAAF;AACF;AAGA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,uBAAA;AADF;ACvEE;EAAA;ID2EE,qBAAA;EAAF;AACF;AAGA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;AADF;AAIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;UAAA,cAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EAAA,yBAAA;EACA,4CAAA;AAFF;AAIE;EACE,qBAAA;EACA,mBAAA;AAFJ;AAII;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,wCAAA;UAAA,gCAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAFN;AAME;EACE,qBAAA;EACA,4CAAA;AAJJ;AAQA;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;AANF;AC1HE;EAAA;IDmIE,kBAAA;EALF;AACF;AAQA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,SAAA;EACA,yBAAA;EAAA,sCAAA;UAAA,8BAAA;AANF;ACpIE;EAAA;ID6IE,WAAA;IACA,WAAA;IACA,cAAA;EALF;AACF;AAQA;EC9EE,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;ED2EA,mBAAA;EAAA,eAAA;UAAA,OAAA;EAEA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;EAAA,yBAAA;ECjFA,mBAAA;EACA,kBAAA;EDkFA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;AAFF;AAIE;EACE,mBAAA;AAFJ;AAKE;EACE,8BAAA;UAAA,sBAAA;AAHJ;ACxKE;EAAA;ID+KE,mBAAA;EAHF;AACF;AAMA;EC/GE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;ED2GA,mBAAA;EAAA,eAAA;UAAA,OAAA;EAEA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;EAAA,yBAAA;EChHA,mBAAA;EACA,kBAAA;EDiHA,mBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,8BAAA;UAAA,sBAAA;AAAJ;AC3ME;EAAA;ID+ME,mBAAA;EAAF;AACF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px); // 背景模糊效果\n  z-index: @z-index-modal;\n  .flex-center();\n  padding: @spacing-md;\n\n  .mobile({\n    padding: @spacing-md;\n  });\n}\n\n.modal {\n  position: relative;\n  background: @white;\n  border-radius: @border-radius-lg;\n  max-width: 25rem; // 400px\n  width: 100%;\n  padding: @spacing-lg @spacing-lg @spacing-xl;\n  box-shadow: @box-shadow-lg;\n  animation: slideUp 0.3s ease;\n\n  .mobile({\n    max-width: 90%;\n    padding: @spacing-md @spacing-lg;\n  });\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(1.25rem); // 20px\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.title {\n  font-size: @font-size-xxl;\n  font-weight: bold;\n  color: #000;\n  text-align: center;\n  margin: 0 0 @spacing-md 0;\n  line-height: 1.4;\n\n  .mobile({\n    font-size: @font-size-xxl;\n  });\n}\n\n.message {\n  font-size: @font-size-md;\n  color: @text-color;\n  text-align: center;\n  margin: 0 0 @spacing-sm 0;\n  line-height: 1.6;\n  font-weight: bold;\n\n  .mobile({\n    font-size: @font-size-md;\n  });\n}\n\n.checkboxContainer {\n  display: flex;\n  justify-content: center;\n  margin: @spacing-lg 0 @spacing-xl 0;\n\n  .mobile({\n    margin: @spacing-md 0 @spacing-md 0;\n  });\n}\n\n.checkboxLabel {\n  display: flex;\n  align-items: center;\n  gap: @spacing-sm;\n  cursor: pointer;\n  user-select: none;\n}\n\n.checkbox {\n  width: 1rem; // 16px\n  height: 1rem; // 16px\n  cursor: pointer;\n  flex-shrink: 0;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  border: 1px solid #d0d0d0; // 浅灰色外圈\n  border-radius: 50%; // 圆形（radio button）\n  background: @white;\n  position: relative;\n  transition: all 0.2s ease;\n  box-shadow: 0 0 2px rgba(208, 208, 208, 0.3); // 轻微模糊边缘效果\n\n  &:checked {\n    border-color: #d0d0d0; // 保持浅灰色外圈\n    background: @white; // 保持白色背景\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      width: 0.75rem; // 12px\n      height: 0.75rem; // 12px\n      border-radius: 50%;\n      background: #5B5B5B; // 深灰色内圈\n    }\n  }\n\n  &:hover {\n    border-color: #b0b0b0;\n    box-shadow: 0 0 3px rgba(208, 208, 208, 0.5);\n  }\n}\n\n.checkboxText {\n  font-size: @font-size-sm;\n  color: @text-color-secondary;\n  font-weight: bolder;\n\n  .mobile({\n    font-size: @font-size-xs;\n  });\n}\n\n.actions {\n  display: flex;\n  gap: @spacing-md;\n  justify-content: space-between;\n\n  .mobile({\n    gap: @spacing-lg;\n    width: 100%;\n    margin: 0 auto;\n  });\n}\n\n.confirmButton {\n  .button-reset();\n  flex: 1;\n  // 框高比 72:25\n  aspect-ratio: 72 / 25;\n  min-height: 1.5625rem; // 25px\n  background: #626CDA; // 紫色背景\n  border: none;\n  border-radius: 999px; // 药丸形状\n  color: @white; // 白色文字\n  font-size: @font-size-md;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  .touch-friendly();\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    background: darken(#626CDA, 10%);\n  }\n\n  &:active {\n    transform: scale(0.98);\n  }\n\n  .mobile({\n    font-size: @font-size-sm;\n  });\n}\n\n.cancelButton {\n  .button-reset();\n  flex: 1;\n  // 框高比 72:25\n  aspect-ratio: 72 / 25;\n  min-height: 1.5625rem; // 25px\n  background: @white; // 白色背景\n  border: 1px solid #d0d0d0; // 灰色边框\n  border-radius: 999px; // 药丸形状\n  color: @text-color-secondary; // 深灰色文字\n  font-size: @font-size-md;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  .touch-friendly();\n  font-weight: normal;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    background: @background-color;\n  }\n\n  &:active {\n    transform: scale(0.98);\n  }\n\n  .mobile({\n    font-size: @font-size-sm;\n  });\n}\n\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `LOX0a0O7`,
	"modal": `gQJkD7ql`,
	"slideUp": `mcKbNPz4`,
	"title": `WApmN42S`,
	"message": `SHk21N_n`,
	"checkboxContainer": `FZw_1agI`,
	"checkboxLabel": `T12XyjTO`,
	"checkbox": `nyWdBqGD`,
	"checkboxText": `yqATvQDr`,
	"actions": `RWMceyS6`,
	"confirmButton": `GdIqccVx`,
	"cancelButton": `JeyKI33F`
};
export default ___CSS_LOADER_EXPORT___;
